import { callApi } from "Apis";
import { DASHBOARDURL } from "helpers/constant";

// Dashboard Count Api...
export async function dashboardCountApi(data) {
  try {
    const response = await callApi({ url: DASHBOARDURL.GET_COUNT, method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Dashboard Booking List Api...
export async function dashboardBookingListApi(data) {
  try {
    const response = await callApi({ url: DASHBOARDURL.GET_BOOKING_LIST, method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Dashboard Members List Api...
export async function dashboardMembersListApi(data) {
  try {
    const response = await callApi({ url: DASHBOARDURL.GET_MEMBER_LIST, method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Dashboard Event List Api...
export async function dashboardEventListApi(data) {
  try {
    const response = await callApi({ url: DASHBOARDURL.GET_EVENT_LIST, method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
